<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">

      <section class="talkshow">

        <div class="talkshowTitle">
          <div class="inner4">
            <h1>主催者公式イベントアーカイブ</h1><p class="titleSub">Official Exhibition Events Archives</p>
          </div><!-- /inner4-->
        </div><!-- /talkshowTitle-->

        <div class="talkshowAbout">
          <div class="inner4">
            <p>
              終了した主催者公式イベントはこちらでご覧いただけます。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->

        <div class="scheduleMenu">
          <div class="scheduleMenuTitle">
            <div class="inner4">
              <h2>主催者公式オンライントークショーアーカイブ</h2>
            </div>
          </div><!-- /scheduleMenuTitle-->
          <div v-if="!talkShowsDateList[0] || !hasArchive()">
            <div class="scheduleList">
              <div class="inner4">
                <h3>
                  現在、アーカイブされている主催者公式オンライントークショーはありません
                </h3>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="scheduleMenuDate" :class="{positionFixed: isScroll}" ref="schedule">
              <div class="inner4">
                <div v-if="talkShowsDateListByMonth(11)" class="scheduleMenuLink m11" :class="{withRightLine: !talkShowsDateListByMonth(12)}">
                  <p>11月</p>
                  <ul class="" style="list-style: none; padding-left: 0px;">
                    <template v-for="date in talkShowsDateListByMonth(11)">
                      <li :key="date">
                        <a style="cursor: pointer;" :class="{ pastColor: isFutureDate(11,date) }" href="#" v-scroll-to="{el:'.d11'+('00' + String(date)).slice(-2),offset:getScrollOffset()}">{{date}}<span>日</span></a>
                      </li>
                    </template>
                  </ul>
                </div>
                <div v-if="talkShowsDateListByMonth(12)" class="scheduleMenuLink m12" :class="{withLeftLine: !talkShowsDateListByMonth(11)}">
                  <p>12月</p>
                  <ul class="" style="list-style: none; padding-left: 0px;">
                    <template v-for="date in talkShowsDateListByMonth(12)">
                      <li :key="date">
                        <a style="cursor: pointer;" :class="{ pastColor: isFutureDate(12,date) }" href="#" v-scroll-to="{el:'.d12'+('00' + String(date)).slice(-2),offset:getScrollOffset()}">{{date}}<span>日</span></a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div><!-- /inner-->
            </div><!-- /scheduleMenuDate-->
            <!-- スケジュールがfixedになると、ref="schedule"のdivが無くなって上方ずれるので、fixedと同時に下記のdivを有効して、ズレをなくす -->
            <div :style="{ display: isScroll ? 'block' : 'none' }" ref="scheduleSpacer">&nbsp;</div>
            <div class="scheduleList">
              <div class="inner4">
                <div class="scheduleListBlock">
                  <template v-for="talkShow in talkShows">
                    <div v-if="!isScheduledTime(talkShow.endAt)" :key="talkShow.id">
                      <div :class="'d' + talkShow.startAt.substr(5, 2) + talkShow.startAt.substr(8, 2)"></div>
                      <TalkShow
                          :talkShow="talkShow"
                          :mode="getMode(talkShow)"
                          :nowDateTime.sync="nowDateTime"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="talkshowAttention ">
          <div class="inner4">
            <p>
              ※トークショー動画の著作権は、東京カメラ部株式会社に帰属します。動画内の写真や音楽などはゲストや他の方の著作物であることがございます。配信される映像、画面、音声を許可なく他のウェブサイトや著作物等に転載することは著作権法で禁じられています。<br>
              ※トークショー動画は、IGTVやYouTubeでも配信する予定です。配信されたオリジナルのIGTVやYouTube動画をSNS上でシェアいただくことは大歓迎しております。<br>
              ※配信には最善の準備を行い実施致しますが、不慮の一時停止や映像・音声の乱れ、インターネット回線のトラブルによる配信の一時中断、技術トラブルによる開始の遅延や開催中止などが発生する可能性もございます。あらかじめご了承ください。<br>
              ※お客様起因による視聴トラブル、およびお客様のインターネット環境に伴う閲覧の不具合に関しましては、当方は責任を負いかねます。<br>
              ※視聴に関わるインターネット通信費、回線費等はお客様のご負担となります。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAttention-->

      </section>
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import TalkShow from '@/components/modules/TalkShow.vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  components: {
    Header,
    Footer,
    TalkShow,
    UpButton
  },
  data () {
    return {
      nowDateTime: null,
      timerId: null,
      holidayList: ['11月3日', '11月23日'],
      isScroll: false,
      schedulePositionY: 0,
    }
  },
  created () {
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
    window.removeEventListener('scroll', this.scrollHandler)
  },
  mounted () {
    // スクロールイベント設定
    window.addEventListener('scroll', this.scrollHandler)
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  methods: {
    getMode (talkShow) {
      if (this.isScheduledTime(talkShow.endAt)) {
        return 'schedule'
      } else {
        return 'archives'
      }
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    // 過去日付の場合falseを返す
    isScheduledDate (talkShowsDate) {
      if (this.nowDateTime > moment('2021年' + talkShowsDate, 'YYYY年M月D日').tz('Asia/Tokyo').endOf('day').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    // トークショーが終了している場合falseを返す
    isScheduledTime (endTime) {
      if (this.nowDateTime > moment(endTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    hasArchive () {
      if (this.nowDateTime >= moment('2021年' + this.talkShowsDateList[0], 'YYYY年M月D日').tz('Asia/Tokyo').endOf('day').format('YYYYMMDD HH:mm:ss')) {
        return true
      }
      return false
    },
    scrollHandler () {
      if ((!this.schedulePositionY || this.schedulePositionY < 0 )  && this.$refs.schedule) {
        const rect = this.$refs.schedule.getBoundingClientRect()
        this.$refs.scheduleSpacer.style.height = this.$refs.schedule.offsetHeight + 'px'
        this.schedulePositionY = rect.top + window.scrollY
      }
      if (window.scrollY > this.schedulePositionY) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    getScrollOffset () {
      return -107
    },
    isFutureDate(month,date) {
      const key = month +'月'+date+'日'
      if(!this.isScheduledDate(key)) {
        return false
      } else if(this.nowDateTime.substr(0,4) =='2021' && Number(this.nowDateTime.substr(4,2)) == month && Number(this.nowDateTime.substr(6,2)) == date){
        // 当日の場合、終了しているトークショーがあればfalse
        if(!this.isScheduledTime(this.talkShowsByDate(key)[0].endAt)) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    ...mapGetters([
      'talkShows',
      'talkShowsDateList',
      'talkShowsByDate',
      'talkShowsDateListByMonth'
    ]),
    dispDate: function () {
      return function (date) {
        if (date) {
          let dispDate = moment('2021年' + date, 'YYYY年M月D日').tz('Asia/Tokyo').format('M月D日（ddd）')
          if (this.holidayList.indexOf(date) >= 0) {
            dispDate = dispDate.slice(0, -1) + '・祝）'
          }
          return dispDate
        }
      }
    }
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.positionFixed {
  top: 0;
  width:100%;
  position: fixed;
  z-index:1000;
}

.pastColor {
  color: #B7B7B7;
  pointer-events: none;
}
</style>
